// extracted by mini-css-extract-plugin
export default {"quoteText":"Quote_quoteText__1PcwO"};